"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateHoliday = dateHoliday;
const datePart_1 = require("./datePart");
// import { fdate } from './fdate';
const easterDict = [];
/**
 * zwraca nazwę świeta z wybranego dnia
 * @param date
 * @returns
 */
function dateHoliday(date) {
    const { d, m, y } = typeof date != 'string'
        ? {
            d: date.getDate(),
            m: date.getMonth() + 1,
            y: date.getFullYear()
        }
        : {
            d: (0, datePart_1.datePart)(date, 'd'),
            m: (0, datePart_1.datePart)(date, 'M'),
            y: (0, datePart_1.datePart)(date, 'y')
        };
    if (m == 1 && d == 1)
        return 'Nowy Rok'; // Nowy Rok
    if (m == 1 && d == 6)
        return 'Trzech Króli'; // Nowy Rok
    if (m == 5 && d == 1)
        return 'Święto Pracy'; // 1 maja
    if (m == 5 && d == 3)
        return 'Święto Konstytucji 3 Maja'; // 3 maja
    if (m == 8 && d == 15)
        return 'Wniebowzięcie Najświętszej Maryi Panny'; // Wniebowzięcie Najświętszej Marii Panny, Święto Wojska Polskiego
    if (m == 11 && d == 1)
        return 'Wszystkich Świętych'; // Dzień Wszystkich Świętych
    if (m == 11 && d == 11)
        return 'Święto Niepodległości'; // Dzień Niepodległości
    if (m == 12 && d == 25)
        return 'Boże Narodzenie'; // Boże Narodzenie
    if (m == 12 && d == 26)
        return 'Boże Narodzenie'; // Boże Narodzenie
    if (m >= 3 && m <= 6) {
        let easter = easterDict[y];
        if (easter == undefined) {
            const a = y % 19;
            const b = y % 4;
            const c = y % 7;
            let d = (a * 19 + 24) % 30;
            const e = (2 * b + 4 * c + 6 * d + 5) % 7;
            if (d == 29 && e == 6)
                d -= 7;
            if (d == 28 && e == 6 && a > 10)
                d -= 7;
            const dt = new Date(y, 2, 22 + d + e);
            const poniedzialek = new Date(dt.valueOf());
            poniedzialek.setDate(dt.getDate() + 1);
            const zieloneswiatki = new Date(dt.valueOf());
            zieloneswiatki.setDate(dt.getDate() + 49);
            const bozecialo = new Date(dt.valueOf());
            bozecialo.setDate(dt.getDate() + 60);
            easterDict[y] = easter = {
                wielkanoc: [dt.getFullYear(), dt.getMonth() + 1, dt.getDate()],
                poniedzialek: [poniedzialek.getFullYear(), poniedzialek.getMonth() + 1, poniedzialek.getDate()],
                zieloneswiatki: [zieloneswiatki.getFullYear(), zieloneswiatki.getMonth() + 1, zieloneswiatki.getDate()],
                bozecialo: [bozecialo.getFullYear(), bozecialo.getMonth() + 1, bozecialo.getDate()]
            };
        }
        if (easter.wielkanoc[1] == m && easter.wielkanoc[2] == d)
            return 'Wielkanoc';
        if (easter.poniedzialek[1] == m && easter.poniedzialek[2] == d)
            return 'Poniedziałek Wielkanocny';
        if (easter.zieloneswiatki[1] == m && easter.zieloneswiatki[2] == d)
            return 'Zielone Świątki';
        if (easter.bozecialo[1] == m && easter.bozecialo[2] == d)
            return 'Boże Ciało';
    }
    return '';
}
//# sourceMappingURL=dateHoliday.js.map